import React from 'react';
import { I18n } from 'react-redux-i18n';
import { LogoFull } from './NawiIdentity';
import { useNawiChatActions } from './NawiChatContext';

const SUGGESTION_KEYS = [
  'culturalFit',
  'mentoring',
  'leadership',
  'projects',
  'metrics',
  'retention',
];

const WelcomeChat = () => {
  const { sendMessage } = useNawiChatActions();

  return (
    <div className="nawi-chat__welcome">
      <div className="nawi-chat__brand">
        <LogoFull height={52} />
      </div>
      <h2>{I18n.t('persons.nawiChat.title')}</h2>
      <p>{I18n.t('persons.nawiChat.subtitle')}</p>

      <div
        aria-label={I18n.t('persons.nawiChat.suggestionsLabel')}
        className="nawi-chat__suggestions"
      >
        {SUGGESTION_KEYS.map((key) => {
          const suggestion = I18n.t(`persons.nawiChat.suggestions.${key}`);

          return (
            <button
              className="nawi-chat__suggestion"
              key={key}
              onClick={() => sendMessage(suggestion)}
              type="button"
            >
              {suggestion}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WelcomeChat;
